export default __webpack_public_path__ + "static/media/defaultImage.f294d059.jpg";